module.exports = __webpack_public_path__ + "img/Phoenix.99735b60.png";